import map from 'lodash/map'
import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import type { ListField } from '@ztechapps/common.hook'
import { ActionHeaderCell, MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { useUsageListContext } from './Context'

// `constants.ts`'s `usageListFieldConfig` is static and currency-agnostic on purpose — it has no
// owner context of its own and is one shared constant across every owner's table, so a
// currency-interpolated label baked into it would show one owner's currency to another.
// Rendering the header cells here instead, straight off the live `useUsageListContext()` currency,
// sidesteps that for just these two columns — every other column still renders through the field
// config exactly as before.
export const ListHeader = (props: HeaderRowConfig) => {
  const { currency } = useUsageListContext()

  const displayName = (field: ListField) => {
    if (field.name === 'credits') return currency ? `Credits (${currency})` : 'Credits'
    if (field.name === 'markupCcy') return currency ? `Markup (${currency})` : 'Markup'
    if (field.name === 'balanceAfter') return currency ? `Balance After (${currency})` : 'Balance After'
    return field.displayName
  }

  return (
    <>
      <MenuHeaderCell />

      {/* Hand-rolled here instead of props._renderDataHeaderCell() (used by the other custom
          ListHeaders) because that helper returns opaque cells with no per-field label override
          hook — we need it to inject the live currency-suffixed label for `credits`/`markupCcy`. */}
      {map(props._fields, (field) => (
        <ActionHeaderCell key={field.name} field={field}>
          {displayName(field)}
        </ActionHeaderCell>
      ))}
    </>
  )
}
